/**
 * capitalizeFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { capitalize } from '@shared/utils/strings';

export function capitalizeFilter() {
    return capitalize;
}
